const formatPhone = value => {
    return value.replace(/^\d{10}$/g, function (str) {
        return `(${str.substring(0, 2)}) ${str.substring(2, 6)}-${str.substring(6, 10)}`
    });
}

const formatCellPhone = value => {
    return value.replace(/^\d{11}$/g, function (str) {
        return `(${str.substring(0, 2)}) ${str.substring(2, 7)}-${str.substring(7, 11)}`
    });
}

export default {
    formatPhone,
    formatCellPhone,
    formatCep(value) {
        return value.replace(/^\d{8}$/g, function (str) {
            return `${str.substring(0, 2)}.${str.substring(2, 5)}-${str.substring(5, 8)}`
        });
    },
    formatCnpj: value => {
        return value.replace(/^([A-Z\d]{12})(\d{2})$/i, function (_, base, dv) {
            return `${base.substring(0, 2)}.${base.substring(2, 5)}.${base.substring(5, 8)}/${base.substring(8, 12)}-${dv}`;
        });
    },
    formatDnv: value => {
        return value.replace(/^\d{11}$/g, function (str) {
            return `${str.substring(0, 2)}-${str.substring(2, 10)}-${str.substring(10, 11)}`
        });
    },
    formatPhoneOrCellPhone: value => {
        return value && value.length === 10 ? formatPhone(value) : formatCellPhone(value)
    },
    formatDate: value => {

        value = value.replace(/-*\/*/g, '')

        return `${value.substring(6, 8)}/${value.substring(4, 6)}/${value.substring(0, 4)}`
    },
    formatTime: value => {

        value = value.replace(/-*\/*:* */g, '')

        let result = `${value.substring(0, 2)}:${value.substring(2, 4)}`
        return  result
    },
    formatDateTime: value => {

        value = value.replace(/-*\/*:* */g, '')

        let result = `${value.substring(6, 8)}/${value.substring(4, 6)}/${value.substring(0, 4)}`
        result = `${result} ${value.substring(8, 10)}:${value.substring(10, 12)}`

        return  result
    },
    formatCpf: value => {
        return value && value.replace(/^\d{11}$/g, function (str) {
            return `${str.substring(0, 3)}.${str.substring(3, 6)}.${str.substring(6, 9)}-${str.substring(9, 11)}`
        });
    },
    formatCns: value => {
        return value && value.replace(/^\d{15}$/g, function (str) {
            return `${str.substring(0, 3)} ${str.substring(3, 7)} ${str.substring(7, 11)} ${str.substring(11, 15)}`
        });
    },
    formatRg: value => {
        return value.replace(/^\d{9}$/g, function (str) {
            return `${str.substring(0, 2)}.${str.substring(2, 5)}.${str.substring(5, 8)}-${str.substring(8, 9)}`
        });
    },
    formatProcedimento: value => {
        return `${value.substring(0, 2)}.${value.substring(2, 4)}.${value.substring(4, 6)}.${value.substring(6, 9)}-${value.substring(9, 10)}`
    },
    formatCid: value => {
        return `${value.substring(0, 3)}.${value.substring(3, 4)}`
    },
    formatMoney(value, decimal) {
        return `${value.toLocaleString('pt-br', {minimumFractionDigits: decimal})}`
    },
    formatSumMoney(value) {

        value = value.replaceAll('.', '')
        value = value.replaceAll(',', '.')
        value = Number.parseFloat(value)

        return value
    },
    numeroPlaca(value) {
        return `${value.substring(0, 3)}-${value.substring(3, 7)}`
    }
}